import Request from './request';
import snackbar from '@/plugins/snackbar';
import i18n from '@/i18n';
import store from '../store';

async function fetch(data) {
    return Request('get', "api/order-material-analyze/month-analyze", data);
}

async function fetchDetails(data) {
    return Request('get', "api/order-material-analyze/month-analyze-view", data);
}

async function orderExports(data){
    store.dispatch("fullscreenLoading")
    const response = await Request('get',"api/order-material-analyze/month-order-export",data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

async function ReturnOrderExports(data){
    store.dispatch("fullscreenLoading")
    const response = await Request('get',"api/order-material-analyze/month-return-order-export",data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

async function orderDetailExports(data){
    store.dispatch("fullscreenLoading")
    const response = await Request('get',"api/order-material-analyze/month-order-detail-export",data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

async function ReturnOrderDetailExports(data){
    store.dispatch("fullscreenLoading")
    const response = await Request('get',"api/order-material-analyze/month-return-order-detail-export",data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

export default {
    fetch,
    fetchDetails,
    orderExports,
    ReturnOrderExports,
    orderDetailExports,
    ReturnOrderDetailExports,
}